import { Routes, Route } from "react-router-dom";
import PrivateRoute from "../routes/PrivateRoute";

// Auth Pages
import SigninPage from "../Pages/auth/LoginPage";
import { RegisterPage } from "../Pages/auth/RegisterPage";

// User Pages
import DMs from "../Pages/chat/DMs";
import UserListPage from "../Pages/userList/UserListPage";
import AddUserListPage from "../Pages/userList/AddUserListPage";
import { CompanyPage } from "../Pages/auth/CompanyPage";
import HomePage from "../Pages/chat/HomePage";
import CompanyListPage from "../Pages/company/CompanyListPage";
import AddCompanyPage from "../Pages/company/AddCompanyPage";
import Activity from "../Pages/chat/Activity";
import ViewGroup from "../Pages/group/ViewGroup";
import CreateGroup from "../Pages/group/CreateGroup";
import ViewUserAndRole from "../Pages/user&role/ViewUser&Role";
import AddUserAndRole from "../Pages/user&role/AddUser&Role";
import ChannelPage from "../Pages/channel/ViewChannel";
import AddChannelPage from "../Pages/channel/AddChannel";
import LogsPage from "../Pages/Logs/LogsPage";
import AccountSummary from "../Pages/accountsummary/Accountsummary";
import Help from "../Pages/help/Help";
import MyAccountHelp from "../Pages/help/MyAccountHelp";
import HomePanelHelp from "../Pages/help/HomePanelHelp";
import ChatFeaturesHelp from "../Pages/help/ChatFeaturesHelp";
import ActivityHelp from "../Pages/help/ActivityHelp";
import NavigationHelp from "../Pages/help/NavigationHelp";
import SettingsHelp from "../Pages/help/SettingsHelp";
import PrivacyPolicy from "../Pages/privacypolicy/PrivacyPolicy";
import AboutUs from "../Pages/about/about";
import Unauthorized from "../Pages/404/Unauthorized";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route path="/" element={<SigninPage />} />
      <Route path="/login" element={<SigninPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/company" element={<CompanyPage />} />
      <Route path="/Unauthorized" element={<Unauthorized />} />

      {/* General Routes */}
      <Route
        path="/homepage"
        element={
          <PrivateRoute
            element={<HomePage />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />
      <Route
        path="/dms"
        element={
          <PrivateRoute
            element={<DMs />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />
      <Route
        path="/activity"
        element={
          <PrivateRoute
            element={<Activity />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />

      <Route
        path="/userlist"
        element={
          <PrivateRoute
            element={<UserListPage />}
            roles={["admin", "other_user"]}
            module="user"
            requiredAccess="view"
          />
        }
      />
      <Route
        path="/userlist/add"
        element={
          <PrivateRoute
            element={<AddUserListPage />}
            roles={["admin", "other_user"]}
            module="user"
            requiredAccess="add"
          />
        }
      />
      <Route
        path="/companylist"
        element={
          <PrivateRoute
            element={
              <PrivateRoute element={<CompanyListPage />} roles={["admin"]} />
            }
          />
        }
      />
      <Route
        path="/companylist/add"
        element={
          <PrivateRoute element={<AddCompanyPage />} roles={["admin"]} />
        }
      />
      <Route
        path="/group"
        element={
          <PrivateRoute
            element={<ViewGroup />}
            roles={["admin", "other_user"]}
            module="group"
            requiredAccess="view"
          />
        }
      />
      <Route
        path="/group/add"
        element={
          <PrivateRoute
            element={<CreateGroup />}
            roles={["admin", "other_user"]}
            module="group"
            requiredAccess="add"
          />
        }
      />
      <Route
        path="/channel"
        element={
          <PrivateRoute
            element={<ChannelPage />}
            roles={["admin", "other_user"]}
            module="channel"
            requiredAccess="view"
          />
        }
      />
      <Route
        path="/channel/add"
        element={
          <PrivateRoute
            element={<AddChannelPage />}
            roles={["admin", "other_user"]}
            module="channel"
            requiredAccess="add"
          />
        }
      />
      <Route
        path="/userandrole"
        element={
          <PrivateRoute element={<ViewUserAndRole />} roles={["admin"]} />
        }
      />
      <Route
        path="/userandrole/add"
        element={
          <PrivateRoute
            element={
              <PrivateRoute element={<AddUserAndRole />} roles={["admin"]} />
            }
          />
        }
      />
      <Route
        path="/logs"
        element={
          <PrivateRoute
            element={<LogsPage />}
            roles={["admin", "other_user"]}
          />
        }
      />
      <Route
        path="/accountsummary"
        element={
          <PrivateRoute
            element={<AccountSummary />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />
      <Route
        path="/help"
        element={
          <PrivateRoute
            element={<Help />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />
      <Route
        path="/help/my-account"
        element={
          <PrivateRoute
            element={<MyAccountHelp />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />

      <Route
        path="/help/home-panel"
        element={
          <PrivateRoute
            element={<HomePanelHelp />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />
      <Route
        path="/help/chat-features"
        element={
          <PrivateRoute
            element={<ChatFeaturesHelp />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />
      <Route
        path="/help/activity"
        element={
          <PrivateRoute
            element={<ActivityHelp />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />
      <Route
        path="/help/navigation"
        element={
          <PrivateRoute
            element={<NavigationHelp />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />
      <Route
        path="/help/settings"
        element={
          <PrivateRoute
            element={<SettingsHelp />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />

      <Route
        path="/privacy-policy"
        element={
          <PrivateRoute
            element={<PrivacyPolicy />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />
      <Route
        path="/aboutus"
        element={
          <PrivateRoute
            element={<AboutUs />}
            roles={["admin", "staff", "other_user"]}
          />
        }
      />
    </Routes>
  );
};

export default AppRoutes;
